// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Field Status Icon System
 * 
 * Provides visual status indicators for form field validation
 * using colored circular icons positioned inside input fields
 */

/* Container for input field with status icon */
.field-with-status-icon {
  position: relative !important;
  display: inline-block;
  width: 100%;
}

/* Status icon base styles - PROPERLY CENTERED VERTICALLY */
.field-status-icon {
  position: absolute !important;
  right: 8px !important;
  top: 40% !important;
  transform: translateY(-50%) !important;
  width: 14px !important;
  height: 14px !important;
  border-radius: 50% !important;
  pointer-events: none !important;
  z-index: 10 !important;
  opacity: 0 !important;
  transition: all 0.2s ease !important;
}

/* Show icon when field has been interacted with */
.field-status-icon.visible {
  opacity: 1 !important;
}

/* Status states with icons */
.field-status-icon.status-neutral {
  background-color: #D1D5DB !important;
  border: 1px solid #9CA3AF !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.field-status-icon.status-neutral::before {
  content: '−' !important;
  color: #6B7280 !important;
  font-size: 10px !important;
  font-weight: bold !important;
  line-height: 1 !important;
}

.field-status-icon.status-error {
  background-color: #EF4444 !important;
  border: 1px solid #DC2626 !important;
  animation: pulse-error 0.3s ease-in-out;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.field-status-icon.status-error::before {
  content: '!' !important;
  color: white !important;
  font-size: 9px !important;
  font-weight: bold !important;
  line-height: 1 !important;
}

.field-status-icon.status-valid {
  background-color: #10B981 !important;
  border: 1px solid #059669 !important;
  animation: pulse-success 0.3s ease-in-out;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.field-status-icon.status-valid::before {
  content: '✓' !important;
  color: white !important;
  font-size: 8px !important;
  font-weight: bold !important;
  line-height: 1 !important;
}

/* Subtle animations for state changes */
@keyframes pulse-error {
  0% { transform: translateY(-50%) scale(1); }
  50% { transform: translateY(-50%) scale(1.1); }
  100% { transform: translateY(-50%) scale(1); }
}

@keyframes pulse-success {
  0% { transform: translateY(-50%) scale(1); }
  50% { transform: translateY(-50%) scale(1.1); }
  100% { transform: translateY(-50%) scale(1); }
}

/* Ensure proper spacing for fields with icons */
.field-with-status-icon input,
.field-with-status-icon textarea {
  padding-right: 28px !important; /* Make room for icon */
}

/* Special handling for different field types */
.field-with-status-icon select {
  padding-right: 40px; /* More space for dropdown arrow + icon */
}

/* Responsive adjustments for mobile */
@media (max-width: 768px) {
  .field-status-icon {
    width: 12px !important;
    height: 12px !important;
    right: 6px !important;
  }
  
  .field-status-icon.status-neutral::before {
    font-size: 10px !important;
  }
  
  .field-status-icon.status-error::before {
    font-size: 9px !important;
  }
  
  .field-status-icon.status-valid::before {
    font-size: 8px !important;
  }
  
  .field-with-status-icon input,
  .field-with-status-icon textarea {
    padding-right: 36px;
  }
  
  .field-with-status-icon select {
    padding-right: 44px;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .field-status-icon.status-neutral {
    background-color: #6B7280;
    border: 2px solid #4B5563;
  }
  
  .field-status-icon.status-neutral::before {
    color: white;
    font-weight: 900;
  }
  
  .field-status-icon.status-error {
    background-color: #DC2626;
    border: 2px solid #991B1B;
  }
  
  .field-status-icon.status-error::before {
    color: white;
    font-weight: 900;
  }
  
  .field-status-icon.status-valid {
    background-color: #059669;
    border: 2px solid #047857;
  }
  
  .field-status-icon.status-valid::before {
    color: white;
    font-weight: 900;
  }
}

/* Reduced motion preference */
@media (prefers-reduced-motion: reduce) {
  .field-status-icon {
    transition: opacity 0.1s ease;
  }
  
  @keyframes pulse-error {
    0%, 100% { transform: translateY(-50%) scale(1); }
  }
  
  @keyframes pulse-success {
    0%, 100% { transform: translateY(-50%) scale(1); }
  }
}

/* Focus state adjustments */
.field-with-status-icon input:focus,
.field-with-status-icon textarea:focus,
.field-with-status-icon select:focus {
  outline-offset: 2px;
}

/* Dark mode support (if applicable) */
@media (prefers-color-scheme: dark) {
  .field-status-icon.status-neutral {
    background-color: #6B7280;
    border: 1px solid #4B5563;
  }
}

/* Email Domain Correction Suggestions */
.email-suggestion-tooltip {
  position: absolute !important;
  top: calc(100% + 8px) !important;
  left: 0 !important;
  right: 0 !important;
  background: #1F2937 !important;
  color: white !important;
  padding: 12px 16px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  z-index: 100 !important;
  opacity: 0 !important;
  transform: translateY(-4px) !important;
  transition: all 0.2s ease !important;
  pointer-events: none !important;
  border: 1px solid #374151 !important;
}

.email-suggestion-tooltip.visible {
  opacity: 1 !important;
  transform: translateY(0) !important;
  pointer-events: auto !important;
}

.email-suggestion-tooltip::before {
  content: '' !important;
  position: absolute !important;
  top: -6px !important;
  left: 20px !important;
  width: 0 !important;
  height: 0 !important;
  border-left: 6px solid transparent !important;
  border-right: 6px solid transparent !important;
  border-bottom: 6px solid #1F2937 !important;
}

.suggestion-text {
  margin: 0 0 8px 0 !important;
  font-weight: 500 !important;
}

.suggested-email {
  background: #3B82F6 !important;
  color: white !important;
  padding: 6px 12px !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  display: inline-block !important;
  font-family: monospace !important;
  font-size: 13px !important;
  transition: background 0.2s ease !important;
  border: 1px solid #2563EB !important;
}

.suggested-email:hover {
  background: #2563EB !important;
  border-color: #1D4ED8 !important;
}

/* Email Tips Tooltip (for 'i' icon) */
.email-tips-tooltip {
  position: absolute !important;
  top: calc(100% + 8px) !important;
  left: 0 !important;
  right: 0 !important;
  background: #059669 !important;
  color: white !important;
  padding: 16px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  line-height: 1.5 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  z-index: 100 !important;
  opacity: 0 !important;
  transform: translateY(-4px) !important;
  transition: all 0.2s ease !important;
  pointer-events: none !important;
  border: 1px solid #047857 !important;
}

.email-tips-tooltip.visible {
  opacity: 1 !important;
  transform: translateY(0) !important;
  pointer-events: auto !important;
}

.email-tips-tooltip::before {
  content: '' !important;
  position: absolute !important;
  top: -6px !important;
  right: 20px !important;
  width: 0 !important;
  height: 0 !important;
  border-left: 6px solid transparent !important;
  border-right: 6px solid transparent !important;
  border-bottom: 6px solid #059669 !important;
}

.tips-title {
  font-weight: 600 !important;
  margin-bottom: 8px !important;
  font-size: 14px !important;
}

.tips-list {
  margin: 0 !important;
  padding-left: 16px !important;
}

.tips-list li {
  margin-bottom: 4px !important;
}

/* Info icon for email tips */
.email-info-icon {
  position: absolute !important;
  right: 32px !important;
  top: 40% !important;
  transform: translateY(-50%) !important;
  width: 16px !important;
  height: 16px !important;
  border-radius: 50% !important;
  background: #6B7280 !important;
  color: white !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 11px !important;
  font-weight: bold !important;
  cursor: help !important;
  z-index: 11 !important;
  opacity: 0.7 !important;
  transition: all 0.2s ease !important;
  font-family: Arial, sans-serif !important;
}

.email-info-icon:hover {
  opacity: 1 !important;
  background: #4B5563 !important;
}

.email-info-icon::before {
  content: 'i' !important;
  line-height: 1 !important;
}`, "",{"version":3,"sources":["webpack://./src/formatting/validation/validation-icons.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,+CAA+C;AAC/C;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,WAAW;AACb;;AAEA,2DAA2D;AAC3D;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,kDAAkD;AAClD;EACE,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;EACpC,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,uCAAuC;EACvC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yCAAyC;EACzC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,KAAK,oCAAoC,EAAE;EAC3C,MAAM,sCAAsC,EAAE;EAC9C,OAAO,oCAAoC,EAAE;AAC/C;;AAEA;EACE,KAAK,oCAAoC,EAAE;EAC3C,MAAM,sCAAsC,EAAE;EAC9C,OAAO,oCAAoC,EAAE;AAC/C;;AAEA,gDAAgD;AAChD;;EAEE,8BAA8B,EAAE,uBAAuB;AACzD;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB,EAAE,yCAAyC;AAChE;;AAEA,sCAAsC;AACtC;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAW,oCAAoC,EAAE;EACnD;;EAEA;IACE,WAAW,oCAAoC,EAAE;EACnD;AACF;;AAEA,4BAA4B;AAC5B;;;EAGE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;AACF;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,qDAAqD;EACrD,uBAAuB;EACvB,qBAAqB;EACrB,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;EACjC,0BAA0B;EAC1B,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,qDAAqD;EACrD,uBAAuB;EACvB,qBAAqB;EACrB,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B","sourcesContent":["/**\n * Field Status Icon System\n * \n * Provides visual status indicators for form field validation\n * using colored circular icons positioned inside input fields\n */\n\n/* Container for input field with status icon */\n.field-with-status-icon {\n  position: relative !important;\n  display: inline-block;\n  width: 100%;\n}\n\n/* Status icon base styles - PROPERLY CENTERED VERTICALLY */\n.field-status-icon {\n  position: absolute !important;\n  right: 8px !important;\n  top: 40% !important;\n  transform: translateY(-50%) !important;\n  width: 14px !important;\n  height: 14px !important;\n  border-radius: 50% !important;\n  pointer-events: none !important;\n  z-index: 10 !important;\n  opacity: 0 !important;\n  transition: all 0.2s ease !important;\n}\n\n/* Show icon when field has been interacted with */\n.field-status-icon.visible {\n  opacity: 1 !important;\n}\n\n/* Status states with icons */\n.field-status-icon.status-neutral {\n  background-color: #D1D5DB !important;\n  border: 1px solid #9CA3AF !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.field-status-icon.status-neutral::before {\n  content: '−' !important;\n  color: #6B7280 !important;\n  font-size: 10px !important;\n  font-weight: bold !important;\n  line-height: 1 !important;\n}\n\n.field-status-icon.status-error {\n  background-color: #EF4444 !important;\n  border: 1px solid #DC2626 !important;\n  animation: pulse-error 0.3s ease-in-out;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.field-status-icon.status-error::before {\n  content: '!' !important;\n  color: white !important;\n  font-size: 9px !important;\n  font-weight: bold !important;\n  line-height: 1 !important;\n}\n\n.field-status-icon.status-valid {\n  background-color: #10B981 !important;\n  border: 1px solid #059669 !important;\n  animation: pulse-success 0.3s ease-in-out;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.field-status-icon.status-valid::before {\n  content: '✓' !important;\n  color: white !important;\n  font-size: 8px !important;\n  font-weight: bold !important;\n  line-height: 1 !important;\n}\n\n/* Subtle animations for state changes */\n@keyframes pulse-error {\n  0% { transform: translateY(-50%) scale(1); }\n  50% { transform: translateY(-50%) scale(1.1); }\n  100% { transform: translateY(-50%) scale(1); }\n}\n\n@keyframes pulse-success {\n  0% { transform: translateY(-50%) scale(1); }\n  50% { transform: translateY(-50%) scale(1.1); }\n  100% { transform: translateY(-50%) scale(1); }\n}\n\n/* Ensure proper spacing for fields with icons */\n.field-with-status-icon input,\n.field-with-status-icon textarea {\n  padding-right: 28px !important; /* Make room for icon */\n}\n\n/* Special handling for different field types */\n.field-with-status-icon select {\n  padding-right: 40px; /* More space for dropdown arrow + icon */\n}\n\n/* Responsive adjustments for mobile */\n@media (max-width: 768px) {\n  .field-status-icon {\n    width: 12px !important;\n    height: 12px !important;\n    right: 6px !important;\n  }\n  \n  .field-status-icon.status-neutral::before {\n    font-size: 10px !important;\n  }\n  \n  .field-status-icon.status-error::before {\n    font-size: 9px !important;\n  }\n  \n  .field-status-icon.status-valid::before {\n    font-size: 8px !important;\n  }\n  \n  .field-with-status-icon input,\n  .field-with-status-icon textarea {\n    padding-right: 36px;\n  }\n  \n  .field-with-status-icon select {\n    padding-right: 44px;\n  }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .field-status-icon.status-neutral {\n    background-color: #6B7280;\n    border: 2px solid #4B5563;\n  }\n  \n  .field-status-icon.status-neutral::before {\n    color: white;\n    font-weight: 900;\n  }\n  \n  .field-status-icon.status-error {\n    background-color: #DC2626;\n    border: 2px solid #991B1B;\n  }\n  \n  .field-status-icon.status-error::before {\n    color: white;\n    font-weight: 900;\n  }\n  \n  .field-status-icon.status-valid {\n    background-color: #059669;\n    border: 2px solid #047857;\n  }\n  \n  .field-status-icon.status-valid::before {\n    color: white;\n    font-weight: 900;\n  }\n}\n\n/* Reduced motion preference */\n@media (prefers-reduced-motion: reduce) {\n  .field-status-icon {\n    transition: opacity 0.1s ease;\n  }\n  \n  @keyframes pulse-error {\n    0%, 100% { transform: translateY(-50%) scale(1); }\n  }\n  \n  @keyframes pulse-success {\n    0%, 100% { transform: translateY(-50%) scale(1); }\n  }\n}\n\n/* Focus state adjustments */\n.field-with-status-icon input:focus,\n.field-with-status-icon textarea:focus,\n.field-with-status-icon select:focus {\n  outline-offset: 2px;\n}\n\n/* Dark mode support (if applicable) */\n@media (prefers-color-scheme: dark) {\n  .field-status-icon.status-neutral {\n    background-color: #6B7280;\n    border: 1px solid #4B5563;\n  }\n}\n\n/* Email Domain Correction Suggestions */\n.email-suggestion-tooltip {\n  position: absolute !important;\n  top: calc(100% + 8px) !important;\n  left: 0 !important;\n  right: 0 !important;\n  background: #1F2937 !important;\n  color: white !important;\n  padding: 12px 16px !important;\n  border-radius: 8px !important;\n  font-size: 14px !important;\n  line-height: 1.4 !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n  z-index: 100 !important;\n  opacity: 0 !important;\n  transform: translateY(-4px) !important;\n  transition: all 0.2s ease !important;\n  pointer-events: none !important;\n  border: 1px solid #374151 !important;\n}\n\n.email-suggestion-tooltip.visible {\n  opacity: 1 !important;\n  transform: translateY(0) !important;\n  pointer-events: auto !important;\n}\n\n.email-suggestion-tooltip::before {\n  content: '' !important;\n  position: absolute !important;\n  top: -6px !important;\n  left: 20px !important;\n  width: 0 !important;\n  height: 0 !important;\n  border-left: 6px solid transparent !important;\n  border-right: 6px solid transparent !important;\n  border-bottom: 6px solid #1F2937 !important;\n}\n\n.suggestion-text {\n  margin: 0 0 8px 0 !important;\n  font-weight: 500 !important;\n}\n\n.suggested-email {\n  background: #3B82F6 !important;\n  color: white !important;\n  padding: 6px 12px !important;\n  border-radius: 4px !important;\n  cursor: pointer !important;\n  display: inline-block !important;\n  font-family: monospace !important;\n  font-size: 13px !important;\n  transition: background 0.2s ease !important;\n  border: 1px solid #2563EB !important;\n}\n\n.suggested-email:hover {\n  background: #2563EB !important;\n  border-color: #1D4ED8 !important;\n}\n\n/* Email Tips Tooltip (for 'i' icon) */\n.email-tips-tooltip {\n  position: absolute !important;\n  top: calc(100% + 8px) !important;\n  left: 0 !important;\n  right: 0 !important;\n  background: #059669 !important;\n  color: white !important;\n  padding: 16px !important;\n  border-radius: 8px !important;\n  font-size: 13px !important;\n  line-height: 1.5 !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n  z-index: 100 !important;\n  opacity: 0 !important;\n  transform: translateY(-4px) !important;\n  transition: all 0.2s ease !important;\n  pointer-events: none !important;\n  border: 1px solid #047857 !important;\n}\n\n.email-tips-tooltip.visible {\n  opacity: 1 !important;\n  transform: translateY(0) !important;\n  pointer-events: auto !important;\n}\n\n.email-tips-tooltip::before {\n  content: '' !important;\n  position: absolute !important;\n  top: -6px !important;\n  right: 20px !important;\n  width: 0 !important;\n  height: 0 !important;\n  border-left: 6px solid transparent !important;\n  border-right: 6px solid transparent !important;\n  border-bottom: 6px solid #059669 !important;\n}\n\n.tips-title {\n  font-weight: 600 !important;\n  margin-bottom: 8px !important;\n  font-size: 14px !important;\n}\n\n.tips-list {\n  margin: 0 !important;\n  padding-left: 16px !important;\n}\n\n.tips-list li {\n  margin-bottom: 4px !important;\n}\n\n/* Info icon for email tips */\n.email-info-icon {\n  position: absolute !important;\n  right: 32px !important;\n  top: 40% !important;\n  transform: translateY(-50%) !important;\n  width: 16px !important;\n  height: 16px !important;\n  border-radius: 50% !important;\n  background: #6B7280 !important;\n  color: white !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 11px !important;\n  font-weight: bold !important;\n  cursor: help !important;\n  z-index: 11 !important;\n  opacity: 0.7 !important;\n  transition: all 0.2s ease !important;\n  font-family: Arial, sans-serif !important;\n}\n\n.email-info-icon:hover {\n  opacity: 1 !important;\n  background: #4B5563 !important;\n}\n\n.email-info-icon::before {\n  content: 'i' !important;\n  line-height: 1 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
